import { Routes } from '@angular/router';

import { PRIMARY_COURSE_ID } from './course.constants';
import { courseAvailabilityGuard } from './guards/course-availability.guard';
import { moduleAccessGuard } from './guards/module-access.guard';

export const applicationRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: `kurse/${PRIMARY_COURSE_ID}/uebersicht`,
  },
  {
    path: 'kursstart',
    pathMatch: 'full',
    redirectTo: `kurse/${PRIMARY_COURSE_ID}/uebersicht`,
  },
  {
    path: 'kurse/vibe-coding-agentic-ai',
    pathMatch: 'full',
    redirectTo: `kurse/${PRIMARY_COURSE_ID}`,
  },
  {
    path: 'kurse/:courseId',
    pathMatch: 'full',
    canActivate: [courseAvailabilityGuard],
    loadComponent: () => import('./pages/kursstart/kursstart.component')
      .then((module) => module.KursstartComponent),
  },
  {
    path: 'scenario-preview',
    loadComponent: () => import('./pages/scenario-preview/scenario-preview.component')
      .then((module) => module.ScenarioPreviewComponent),
  },
  {
    path: 'kurse/:courseId',
    canActivate: [courseAvailabilityGuard],
    loadComponent: () => import('./pages/learning-shell/learning-shell.component')
      .then((module) => module.LearningShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'module/module-01-grundlagen-des-ai-coding',
      },
      {
        path: 'uebersicht',
        pathMatch: 'full',
        redirectTo: 'module/module-01-grundlagen-des-ai-coding',
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/course-overview/course-overview.component')
          .then((module) => module.CourseOverviewComponent),
      },
      {
        path: 'module/:moduleId/lektion/:lessonId/baustein/:blockId',
        loadComponent: () => import('./pages/external-lesson-page/external-lesson-page.component')
          .then((module) => module.ExternalLessonPageComponent),
        canActivate: [moduleAccessGuard],
      },
      {
        path: 'module/:moduleId/lektion/:lessonId',
        loadComponent: () => import('./pages/external-lesson-page/external-lesson-page.component')
          .then((module) => module.ExternalLessonPageComponent),
        canActivate: [moduleAccessGuard],
      },
      {
        path: 'module/:moduleId',
        loadComponent: () => import('./pages/external-module-start-page/external-module-start-page.component')
          .then((module) => module.ExternalModuleStartPageComponent),
        canActivate: [moduleAccessGuard],
      },
      {
        path: 'zusammenfassung',
        loadComponent: () => import('./pages/zusammenfassung/zusammenfassung.component')
          .then((module) => module.ZusammenfassungComponent),
      },
    ],
  },
];

export const fallbackRoute: Routes[number] = {
  path: '**',
  redirectTo: '',
};
